import React from 'react';
import { Card } from 'semantic-ui-react';
import 'semantic-ui-less/definitions/views/card.less';

export default Card;
